module.exports = __webpack_public_path__ + "img/stock7.7185d609.png";